/**
 * Simple invalidation system for local data hooks.
 * When a mutation changes a table, it calls invalidate(tableName)
 * which triggers all hooks watching that table to re-fetch.
 */

type Listener = () => void;

const listeners = new Map<string, Set<Listener>>();

export function subscribe(table: string, listener: Listener): () => void {
  if (!listeners.has(table)) {
    listeners.set(table, new Set());
  }
  listeners.get(table)!.add(listener);
  return () => {
    listeners.get(table)?.delete(listener);
  };
}

export function invalidate(...tables: string[]): void {
  for (const table of tables) {
    listeners.get(table)?.forEach((listener) => listener());
  }
}
